<template>
  <el-dialog class="workorder-handle-modal" title="工单办结" :visible.sync="visible" width="400px">
    <div class="content" v-loading="loading">
      <div>
        <div class="title">办结原因：</div>
        <el-input v-model="reason" type="textarea" rows="4" placeholder="请输入原因"></el-input>
      </div>
      <div>
        <div class="title">办结备注：</div>
        <el-input v-model="remark" type="textarea" rows="4" placeholder="请输入备注"></el-input>
      </div>
      <div>
        <el-button type="primary" size="small" @click="handle">确定办结</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import qs from 'qs'
  import ModalMixin from '@/libs/modal/modal-mixin'

  export default {
    mixins: [ModalMixin],
    data () {
      return {
        loading: false,
        oid: '',
        reason: '',
        remark: ''
      }
    },
    methods: {
      init (oid) {
        this.oid = oid
        return this.open()
      },
      handle () {
        this.loading = true
        this.Service.call('workorder/handle', 'POST', qs.stringify({
          id: this.oid,
          handledResult: this.reason,
          handledRemark: this.remark
        }), null, null, null, 'application/x-www-form-urlencoded').then(() => {
          this.$message.success('工单办结成功')
          this.close(true)
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
